import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=4f320732&scoped=true"
import script from "./PageLoader.vue?vue&type=script&lang=js"
export * from "./PageLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f320732",
  null
  
)

export default component.exports